"use client";

import type { ReactNode } from "react";

export interface HeroSplitFeaturesListItem {
  icon?: ReactNode;
  label: string;
  id?: string | null;
}

export function HeroSplitFeaturesList({ items }: { items: HeroSplitFeaturesListItem[] }) {
  if (!items.length) return null;

  return (
    <ul className='tw-flex tw-flex-wrap tw-gap-3 tw-max-w-[80%]'>
      {items.map((item, i) => (
        <li key={item.id ?? i} className='tw-flex tw-items-center tw-gap-3'>
          {item.icon}
          <span className='tw-type-xs tw-text-gray-500'>{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
